import React from 'react';
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete';
import {Alert} from 'react-bootstrap';
import agent from '../../agent';
import InfoModal from '../../components/Utils/InfoModal';
import {getLabel} from "../../language";
import {connect} from 'react-redux';
import {fetchUser} from '../../actions/user';
import Loader from "../Loader";
import { waitForGoogleMaps, isGoogleMapsLoaded } from '../../utils/googleMapsLoader';
import ErrorBoundary from './ErrorBoundary';

const mapStateToProps = state => ({
    ...state.auth, anonymousMode: state.user.anonymousMode
});
const mapDispatchToProps = dispatch => ({
    fetchUser: (userName) => dispatch(fetchUser(userName))
});

const AddressForm = (props) => {
    const {anonymousMode, value, isOpen, onChange, onSelect, isDisabled, district, isDefault, id, onChangeDefaultLocation, length, openModal, isGoal} = props;
    let districtVal = district ? `District: ${district}, ` : '';
    
    const displayValue = `${districtVal}${value || ''}`;

    return (
        <div className="row">
            <InfoModal isOpen={isOpen} onClose={openModal} title={getLabel(210)} description={getLabel(211)}
                       video={'https://www.youtube.com/embed/hYxR24ODgBg'}/>
            <div className="col-md-12">
                <ul className="list-group locationlist">
                    <li className="list-group-item">
                        <div id="PlacesAutocomplete__root" className=" form-group">
                            {
                                length > 1 && <div className="divradio">
                                    <input type="radio"
                                           className="form-check-input"
                                           checked={isDefault}
                                           name="isDefault"
                                           id={id}
                                           value={id}
                                           onClick={onChangeDefaultLocation}
                                    />
                                    <label id={id} htmlFor={id}>&nbsp;</label>
                                </div>
                            }
                            <PlacesAutocomplete
                                value={displayValue}
                                onChange={onChange}
                                onSelect={onSelect}
                                searchOptions={{
                                    types: ['address'],
                                }}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            {...getInputProps({
                                                placeholder: 'Search Places...',
                                                className: `form-control${anonymousMode ? "-dark cw" : ""} form-control-lg`,
                                                disabled: isDisabled,
                                            })}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            zIndex: 999,
                                            border: suggestions.length > 0 ? '1px solid #ddd' : 'none',
                                            borderRadius: '0.25rem',
                                            overflow: 'hidden',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            backgroundColor: 'white',
                                            maxHeight: '200px',
                                            overflowY: 'auto'
                                        }}>
                                            {loading && <div style={{ padding: '10px' }}>Loading...</div>}
                                            {suggestions.map(suggestion => {
                                                const className = suggestion.active
                                                    ? 'suggestion-item--active'
                                                    : 'suggestion-item';
                                                const style = suggestion.active
                                                    ? { backgroundColor: '#fafafa', cursor: 'pointer', padding: '10px' }
                                                    : { backgroundColor: '#ffffff', cursor: 'pointer', padding: '10px' };
                                                
                                                return (
                                                    <div
                                                        {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                            style,
                                                        })}
                                                        key={suggestion.placeId}
                                                    >
                                                        <i className="fa fa-map-marker" style={{ marginRight: '8px' }}/>
                                                        <span>{suggestion.description}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                            <button
                                className={`btn btn-outline-danger btn-mini${anonymousMode ? "-dark" : ""} voter-location-delete`}
                                onClick={props.onDelete} hidden={!isDisabled}>
                                <i className="fa fa-trash"/>
                            </button>
                            <a className={`btn btn-outline-danger btn-mini${anonymousMode ? "-dark" : ""} voter-location-delete `}
                               title="help" style={{marginLeft:'5px'}}
                               onClick={openModal} hidden={isGoal}>
                                <i className={`fa fa-question-circle${anonymousMode ? "-dark" : ""} pol`}
                                   style={{fontSize: 25}}/>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

class VoterLocBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search_fields: [{search_address: ''}],
            fields: [{
                id: null,
                isDisabled: false,
                street_number: '',
                route: '',
                locality: '',
                administrative_area_level_1: '',
                administrative_area_level_2: '',
                postal_code: '',
                country: '',
                lat: '',
                lng: '',
                place_id: '',
                district: ''
            }],
            placeId: null,
            isOpen: false,
            errorMessage: "",
            loader: false,
            googleMapsLoaded: false,
            googleMapsError: null
        };

        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.addAddress = this.addAddress.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onChangeDefaultLocation = this.onChangeDefaultLocation.bind(this);

        if (this.props.fillLocation && !this.props.isGoal) {
            this.onLoad();
        }
    }

    componentDidMount() {
        this.checkGoogleMapsLoading();
    }

    checkGoogleMapsLoading = async () => {
        try {
            if (isGoogleMapsLoaded()) {
                this.setState({ googleMapsLoaded: true });
            } else {
                // Wait for Google Maps to load
                await waitForGoogleMaps(15000); // 15 second timeout
                this.setState({ googleMapsLoaded: true });
            }
        } catch (error) {
            console.error('Google Maps failed to load:', error);
            this.setState({ 
                googleMapsError: 'Google Maps failed to load. Please refresh the page and try again.',
                googleMapsLoaded: false 
            });
        }
    }

    onLoad() {
        agent.UserLocations.get(null).then(response => {
            if (!response)
                return;

            let fieldsArray = [];
            let searchFields = [];

            response.map(item => {
                fieldsArray.push({
                    id: item.id,
                    isDisabled: true,
                    street_number: item.street_number,
                    route: item.street,
                    locality: item.city,
                    administrative_area_level_1: item.province,
                    administrative_area_level_2: item.county || '',
                    place_id: item.placeId || '',
                    postal_code: item.postcode,
                    district: item.district,
                    country: item.country,
                    isDefault: item.isDefault,
                });

                let address = "";

                if (item.streetNumber)
                    address += item.streetNumber;

                if (item.street)
                    address += ` ${item.street},`

                searchFields.push({search_address: `${address} ${item.city}, ${item.province}, ${item.country}`});
            });

            if (fieldsArray.length >= 1) {
                this.setState({
                    ...this.state,
                    fields: fieldsArray,
                    search_fields: searchFields
                });
            }
        });
    }

    onChange(index) {
        return address => {
            let tmpSearchFields = this.state.search_fields.slice();
            // Remove the district prefix if it exists to get the clean address
            const cleanAddress = address.replace(/^District: [^,]+, /, '');
            tmpSearchFields[index] = {search_address: cleanAddress};

            this.setState({search_fields: tmpSearchFields, errorMessage: ""})
        };
    }

    onSelect(index) {
        return event => {
            let tmpObj = {};
            let fields = Object.keys(this.state.fields[index]);
            let formsArray = this.state.fields.slice();
            let searchArray = this.state.search_fields.slice();

            formsArray[index] = fields.reduce((prev, cur) => ({...prev, [cur]: ''}), {});

            this.setState({...this.state, fields: formsArray});

            geocodeByAddress(event).then(result => {
                result[0].address_components.forEach(item => {
                    item.types.forEach(type => {
                        if (fields.indexOf(type) != -1) {
                            tmpObj[type] = item.short_name;
                        }
                    });
                });

                tmpObj.place_id = result[0].place_id;
                tmpObj.lat = result[0].geometry.location.lat();
                tmpObj.lng = result[0].geometry.location.lng();
                searchArray[index] = {search_address: event};
                formsArray[index] = {...formsArray[index], ...tmpObj};

                this.setState({...this.state, fields: formsArray, search_fields: searchArray});

                if (this.props.onLocationSelect) {
                    this.props.onLocationSelect(formsArray);
                }
            }).catch(err => console.log('Oh no!', err));
        };
    }

    onDelete(id, index) {
        if (this.props.isGoal) {
            return () => {
                let fieldsArray = this.state.fields.slice();
                let searchArray = this.state.search_fields.slice();

                fieldsArray.splice(index, 1);
                searchArray.splice(index, 1);

                if (!fieldsArray.length && !searchArray.length) {
                    fieldsArray.push({
                        id: null,
                        isDisabled: false,
                        street_number: '',
                        route: '',
                        locality: '',
                        administrative_area_level_1: '',
                        administrative_area_level_2: '',
                        postal_code: '',
                        district: '',
                        country: ''
                    });

                    // this.props.fetchUser(this.props.currentUser.userName);
                    searchArray.push({search_address: ''});
                }

                this.setState({...this.state, fields: fieldsArray, search_fields: searchArray});
            }
        } else {
            return () => {
                agent.UserLocations.delete(id).then(response => {
                    this.onLoad()
                    // let fieldsArray = this.state.fields.slice();
                    // let searchArray = this.state.search_fields.slice();
                    // fieldsArray.splice(index, 1);
                    // searchArray.splice(index, 1);
                    // if (!fieldsArray.length && !searchArray.length) {
                    //     fieldsArray.push({
                    //         id: null,
                    //         isDisabled: false,
                    //         street_number: '',
                    //         route: '',
                    //         locality: '',
                    //         administrative_area_level_1: '',
                    //         administrative_area_level_2: '',
                    //         postal_code: '',
                    //         district: '',
                    //         country: ''
                    //     });
                    //
                    //     this.props.fetchUser(this.props.currentUser.userName);
                    //     searchArray.push({search_address: ''});
                    // }
                    // this.setState({...this.state, fields: fieldsArray, search_fields: searchArray});
                });
                window.location.reload();
            };
        }
    }

    addAddress() {
        let tmpAddresses = this.state.fields.slice();
        let tmpSearch = this.state.search_fields.slice();

        tmpAddresses.push({
            street_number: '',
            route: '',
            locality: '',
            administrative_area_level_1: '',
            administrative_area_level_2: '',
            postal_code: '',
            country: '',
            district: '',
            isDisabled: false
        });
        tmpSearch.push({search_address: ''});

        this.setState({...this.state, fields: tmpAddresses, search_fields: tmpSearch});
    }

    async saveAddress() {
        const itemToUpdate = this.state.fields.find(res => {
            return !res.id;
        })
        this.setState({
            loader: true
        })
        await agent.UserLocations.save(itemToUpdate).then(response => {
            var obj = this.state.fields.find(x => x.place_id === itemToUpdate.place_id);
            obj.district = response.district;
            obj.id = response.id;
            obj.isDisabled = true;
            if (this.props.onVoterLocationAdded) {
                this.props.onVoterLocationAdded();
            }
            if (this.state.fields.length === 1) {
                this.props.fetchUser(this.props.currentUser && this.props.currentUser.userName);
            }
            this.setState({...this.state, fields: this.state.fields, errorMessage: "",loader:false});
        })
            .catch(error => {
                if(((((error || {}).response || {}).body || {}).responseStatus || {}).errorCode === "Conflict"){
                    this.setState({
                        errorMessage: ""
                    })
                } else {
                    const message = ((((error || {}).response || {}).body || {}).responseStatus || {}).message || ""
                    this.setState({
                        errorMessage: message
                    })
                }
                this.setState({
                    loader:false
                })
            })
    }

    onChangeDefaultLocation(event) {
        const id = event.target.id
        agent.UserLocations.put(id).then(res => {
            if (res) {
                this.onLoad();
            }
        });
    }

    getLength(fields) {
        let length = 0
        if (fields) {
            length = fields.filter(x => x.id).length
        }
        return length
    }

    openModal = () => {
        this.setState({isOpen: !this.state.isOpen})
    }

    render() {
        const {errorMessage, loader, googleMapsLoaded, googleMapsError} = this.state

        let showAddAddressButton = this.state.fields.reduce((prev, cur) => {
            return cur.isDisabled;
        }, false);

        let showSaveAddressButton = this.state.fields.find(cur => {
            return !cur.isDisabled && !!cur.country;
        })

        // Show loading state while Google Maps is loading
        if (!googleMapsLoaded && !googleMapsError) {
            return (
                <div style={{marginBottom: 15}}>
                    <Loader/>
                    <p>Loading location services...</p>
                </div>
            );
        }

        // Show error state if Google Maps failed to load
        if (googleMapsError) {
            return (
                <div className="alert alert-warning" role="alert">
                    <h5>Location Services Unavailable</h5>
                    <p>{googleMapsError}</p>
                    <button 
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </button>
                </div>
            );
        }

        return (
            <ErrorBoundary 
                fallbackMessage="There was an error loading the location picker. Please refresh the page and try again."
                showRetry={true}
            >
                {
                    loader &&
                    <div style={{marginBottom:15}}>
                        <Loader/>
                    </div>
                }
                <div>
                    {errorMessage ? <Alert>{errorMessage}</Alert> : null}
                    {this.state.fields.map(function (formFields, index) {
                        return <AddressForm key={index}
                                            isOpen={this.state.isOpen}
                                            anonymousMode={this.props.anonymousMode}
                                            openModal={this.openModal}
                                            length={this.getLength(this.state.fields)}
                                            onChangeDefaultLocation={this.onChangeDefaultLocation}
                                            onDelete={this.onDelete(this.state.fields[index].id, index)}
                                            isGoal={this.props.isGoal || false}
                                            {...{
                                                value: this.state.search_fields[index] && this.state.search_fields[index].search_address, ...formFields,
                                                onChange: this.onChange(index),
                                                onSelect: this.onSelect(index)
                                            }}
                        />;
                    }.bind(this))
                    }
                    {this.props.multiForms && this.state.fields.length < 2 && showAddAddressButton ?
                        <button type='button' className="btn btn-md btn-primary"
                                onClick={this.addAddress}>{getLabel(212)}</button>
                        :
                        null
                    }
                    {this.props.multiForms && this.state.fields.length <= 2 && showSaveAddressButton ?
                        <button type='button' className="btn btn-md btn-primary"
                                onClick={this.saveAddress}>{getLabel(213)}</button>
                        :
                        null
                    }
                </div>
            </ErrorBoundary>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VoterLocBlock);
